<template>
    <setup_content title="Подготовка объектов оценки">

        <setup_frame title="Проверка полноты данных">
            <template v-slot:buttons>
                <div class="d-flex justify-content-center">
                    <b-button v-if="check_roles([ 'model' ])" variant="outline-primary-secondary" v-on:click="update_counts">
                        <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                    </b-button>
                </div>
            </template>
            
            <statistic :total="objects_count" :stats="stat" :warning="check_stat">
                <template v-slot:warning>
                    <div style="line-height: 1.5rem;">
                        У части объектов оценки характеристики не заполнены.
                        <!-- <br>Дозаполните недостающие значения и проведите проверку снова -->
                    </div>
                </template>
            </statistic>
            
        </setup_frame>

        <setup_frame title="Расчет строительного объема">

            <template v-slot:buttons>                
                <div v-if="check_roles([ 'model' ])" class="d-flex justify-content-center" style="gap: .625rem;">

                    <b-button variant="outline-primary-secondary" v-on:click="update_volume_count">
                        <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                    </b-button>
    
                    <b-button variant="outline-primary-secondary" v-on:click="calculate_volume">
                        <span>Рассчитать</span><base-icon name="calc" size="md" />
                    </b-button>
                    
                </div>
            </template>

            <statistic :total="objects_count" :stats="[['', this.cost_data.volume]]" :warning="cost_data.volume != objects_count">
                <template v-slot:warning>
                    <div style="line-height: 1.5rem;">
                        У части объектов оценки характеристика не заполнена.
                        <!-- <br>Дозаполните недостающие значения и проведите проверку снова или <i>рассчитайте строительный объем</i> -->
                    </div>
                </template>
            </statistic>

        </setup_frame>

    </setup_content>
</template>

<script>

import api from "../../../../../api"
import setup_content from "../setup_assets/content"
import setup_frame from "../setup_assets/frame"
import statistic from "../setup_assets/statistic"

export default
{
    props :
    {
		id : String,
        cost_data : Object,
        objects_count : Number,
    },

    components :
    {
        statistic,
        setup_content,
        setup_frame,
    },

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

		}
	},

    computed :
    {
        stat()
        {
            return [
                [ 'Количество надземных этажей', this.cost_data.floors_above_ground, ],
                [ 'Количество подземных этажей', this.cost_data.floors_under_ground, ],
                [ 'Класс конструктивной системы', this.cost_data.cs, ],
                [ 'Группа капитальности', this.cost_data.capital_group, ],
                [ 'Сейсмичность в баллах', this.cost_data.seismicity, ],
                [ 'Ценовая зона', this.cost_data.price_zone, ],
            ]
        },

        check_stat()
        {
            return this.objects_count != this.cost_data.floors_above_ground
            || this.objects_count != this.cost_data.floors_under_ground
            || this.objects_count != this.cost_data.cs
            || this.objects_count != this.cost_data.capital_group
            || this.objects_count != this.cost_data.seismicity
            || this.objects_count != this.cost_data.price_zone
        },

        options()
        {
            return {
                isStacked: true,
                legend: "none",
                chartArea: {width: '50%'},
				bar : { groupWidth: "95%" },
                height: 320,
                hAxis: {
                    viewWindow:
                    {
                        max: this.objects_count,
                    }
                },
                colors: ['#84C16E', '#F87171']
            }
        }
    },

	methods :
	{

        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

		update_counts()
		{
            if (this.check_roles([ 'model' ]))
            {
                api.call(this, this.service, "update_counts", { id : this.id }, () => this.$emit("need_refresh"))
            }
		},

		update_volume_count()
		{
            if (this.check_roles([ 'model' ]))
            {
                api.call(this, this.service, "update_volume_count", { id : this.id }, () => this.$emit("need_refresh"))
            }
		},

		calculate_volume()
		{
            if (this.check_roles([ 'model' ]))
            {
                api.call_long_operation(this, "Расчет строительного объема", this.service, "calculate_volume", { id : this.id },
                    response =>
                    {
                        this.$emit("need_refresh")

                        api.open_response_url(response)
                    },
					{ success_msg : "Расчет строительного объема завершен" }
                )
            }
		},
	},
}

</script>

